import React, {useState} from 'react';

function calcFinal(e, position, setPosition, resultValidate){
    if (resultValidate.length !== 0) return;
    if (position === 0) {
        setPosition(e.target.closest('.calc-result').querySelector('.section-result').scrollHeight + 90);
    } else {
        setPosition(0)
    }
}

export function BtnCalc({validateMouse, resultValidate, picture, resultObjem}){
    const [position, setPosition] = useState(0);

    const styles = {
        transform: `translateY(${-position}px)`
    }

    return (
        <div onMouseOver={validateMouse} onClick={(e) => calcFinal(e, position, setPosition, resultValidate)} className="calc-result group h-[80px] w-[160px] w-max relative">
           <div className={((resultValidate && resultValidate.length === 0) ? "bg-[#5fb7d9]" : 'bg-[#36819e]') + " flex flex-col items-center text-[#fff] h-[80px] w-[160px] p-6 flex justify-center align-center"}>
              <img src={picture} className="w-[30px] h-[30px]" alt="" />              
              <p className="translate-y-[4px]">Рассчитать</p>
            </div>
            <div className={((resultValidate && resultValidate.length === 0) ? "opacity-0 " : '') + "z-[-1] group-hover:translate-y-[-90px] absolute bottom-0 z-[-1] w-max bg-[#e96464] p-2 rounded text-[#fff] translate-y-[60px] translate-x-[-14px] tr-element-content transition duration-500"}>
              Не все поля заполнены
            </div>
            <div style={styles} className="section-result absolute top-[100%] transition delay-300 w-[300px] left-0 sm:w-max sm:left-[-97px] right-0 m-auto bg-[#fff] p-6 rounded shadow-xl">
              <h2 className="text-[22px] mb-[20px] font-semibold">Результаты</h2>
              <ul className="sm:text-center text-[18px]">
                <li>Объем блоков для наружных стен, м³ <span>{resultObjem && resultObjem.toFixed(2)}</span></li>
              </ul>
          </div>
        </div>
    )
}